import React, { useState } from 'react';
import { 
    Box, 
    Collapse, 
    IconButton, 
    makeStyles, 
    Table, 
    TableBody, 
    TableCell, 
    TableHead, 
    TableRow, 
    Typography 
} from '@material-ui/core';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { PracticaItem } from '../gestionAuditoria/PracticaItem';
import IconEstado from '../UI/IconEstado';

const useRowStyles = makeStyles({
    root: {
        "& > *": {
        borderBottom: "unset",
        },
    },
});

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

export const AutorizacionesModalItem = (props) => {
    const classes = useRowStyles
    const { item } = props;
    const [open, setOpen] = useState(props.expandirPracticas);

    return (
        <>
            <TableRow className={classes.root}>
                <TableCell align="right">
                    {item?.urgente && (
                        <IconEstado
                            texto={"U"}
                            useColorTable={true}
                            extraMarginRight={true}
                            backgroundColor={"red"}
                            descripcion={'Urgente'}
                        />
                    )}
                    <IconEstado
                        useColorTable={true}
                        texto={item?.estadosSolicitud?.letra}
                        backgroundColor={item?.estadosSolicitud?.color}
                        descripcion={item?.estadosSolicitud?.descripcion}
                    />
                </TableCell>
                <TableCell align="center">
                    {new Date(item.fecha).toLocaleString("es", optionsfecha)}
                </TableCell>
                <TableCell align="left">{item.idSolicitud}</TableCell>
                <TableCell align="left">{item.tipoSolicitud.descripcionTipo}</TableCell>
                <TableCell align="left">{item.conInternacion ? 'SI' : 'NO'}</TableCell>
                <TableCell align="left">{item.diagnostico?.problema}</TableCell>
                <TableCell>
                    {item?.practicas.length > 0 && (
                        <IconButton
                            aria-label="expand row"
                            size="medium"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    )}
                </TableCell>
                <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>
                <TableCell align="left">{item.afiliado?.carnet}</TableCell>
                <TableCell align="left">{item.seccional?.descripcion_seccional}</TableCell>
                <TableCell align="left">
                    {item.solicitudesTomadas?.find( item => item.fechaLiberada === null)?.usuarioTomada.userName}
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell
                style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 50 }}
                colSpan={8}
                >
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box margin={1}>
                    <Typography variant="h6" gutterBottom component="div">
                        Practicas
                    </Typography>
                    <Table size="small" aria-label="purchases">
                        <TableHead>
                            <TableRow>
                                <TableCell>Estado Práctica</TableCell>
                                <TableCell>Práctica</TableCell>
                                <TableCell align="right">Cantidad</TableCell>
                                <TableCell>Materiales</TableCell>
                                <TableCell>Institucion</TableCell>
                                {item.conInternacion &&
                                    <TableCell>Profesional</TableCell>
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>
                        {Array.isArray(item?.practicas) &&
                        item?.practicas?.length > 0 &&
                        item.practicas.map((item) => (
                            <PracticaItem
                                key={item?.idCodNom?.toString()}
                                conInternacion={item.conInternacion}
                                item={item}
                            />
                        ))}
                        </TableBody>
                    </Table>
                    </Box>
                </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
}
